import { render, staticRenderFns } from "./AddNewOrder.vue?vue&type=template&id=e7f1256a&scoped=true"
import script from "./AddNewOrder.vue?vue&type=script&lang=ts"
export * from "./AddNewOrder.vue?vue&type=script&lang=ts"
import style0 from "./AddNewOrder.vue?vue&type=style&index=0&id=e7f1256a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f1256a",
  null
  
)

export default component.exports